import { motion } from "framer-motion";
import { PHASES } from "./constants";

// `viewerIsBatting` swaps the "Pitching" label to "Batting" so the side that's
// actually batting sees the right verb. Default false → fall back to the static
// PHASES labels (used in local/solo mode where the viewer is both sides).
//
// `disabledPhaseIds` is a list of phase IDs that should render as inactive — no
// click handler, dimmed, no hover affordance. Used to prevent users from manually
// jumping to a phase that hasn't started (e.g. Fielding before a pitch resolves
// in play).
export default function PhaseNav({ currentPhase, setCurrentPhase, viewerIsBatting = false, disabledPhaseIds = [] }) {
  return (
    <div data-testid="phase-nav" className="flex gap-1 bg-slate-900/50 p-1 rounded-xl">
      {PHASES.map((phase, idx) => {
        const isActive = currentPhase === phase.id;
        const isPast = PHASES.findIndex(p => p.id === currentPhase) > idx;
        const isDisabled = !isActive && disabledPhaseIds.includes(phase.id);
        const label = viewerIsBatting && phase.id === "pitch" ? "Batting" : phase.label;

        return (
          <button
            key={phase.id}
            data-testid={`phase-${phase.id}`}
            onClick={isDisabled ? undefined : () => setCurrentPhase(phase.id)}
            disabled={isDisabled}
            aria-disabled={isDisabled}
            title={isDisabled && phase.id === "fielding" ? "Fielding becomes available once a pitch is in play" : undefined}
            className={`relative flex-1 px-3 py-2.5 rounded-lg text-xs font-bold tracking-wide transition-all duration-200 ${
              isActive
                ? 'text-black'
                : isDisabled
                  ? 'text-slate-700 opacity-50 cursor-not-allowed'
                  : isPast
                    ? 'text-emerald-400 hover:bg-slate-800'
                    : 'text-slate-500 hover:bg-slate-800 hover:text-slate-300'
            }`}
          >
            {isActive && (
              <motion.div
                layoutId="activePhase"
                className="absolute inset-0 bg-gradient-to-r from-amber-400 to-amber-500 rounded-lg shadow-lg shadow-amber-500/30"
                transition={{ type: "spring", bounce: 0.2, duration: 0.4 }}
              />
            )}
            <span className="relative z-10 flex items-center justify-center gap-1.5">
              {isPast && <span className="text-emerald-400">✓</span>}
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
